import { compose, withProps } from "recompose";
import { withRouter } from "react-router";
import CmsPage from "theme/pages/CmsPage/CmsPage";

export default compose(
  withRouter,
  withProps((props) => ({
    id: "home",
  }))
)(CmsPage);
